module.exports = __webpack_public_path__ + "img/head_banner_decor.bbbc2e6.svg";